import delay from './delay';
import moment from 'moment';

// This file mocks a web API by working with the hard-coded data below.
// It uses setTimeout to simulate the delay of an AJAX call.
// All calls return promises.
let timeTrackings = [];

function generateTimeTrackings() {
  let previousWeek = moment().week(moment().subtract(1, 'week').week()).startOf('week');
  let i = 0;
  while (i < 5) {
    let tracking = generateTimeTracking(previousWeek.add((i > 0) ? 1 : 0, 'd'));
    timeTrackings.push(tracking);
    i++;
  }
  let currentWeek = moment().startOf('week');
  i = 0;
  while (i < 5) {
    let tracking = generateTimeTracking(currentWeek.add((i > 0) ? 1 : 0, 'd'));
    timeTrackings.push(tracking);
    i++;
  }
}

function generateTimeTracking(date) {
  let tracking = {
    id: timeTrackings.length + 1,
    date: date.format('YYYY-MM-DD')
  };
  return tracking;
}

class TimeTrackingAPI {
  static getAllTimeTrackings() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        generateTimeTrackings();
        resolve(Object.assign([], timeTrackings));
      }, delay);
    });
  }
}

export default TimeTrackingAPI;



/** WEBPACK FOOTER **
 ** ./src/api/mockTimeTrackingApi.js
 **/